
<div class="chart-container card flex space-around">
    <div class="flex exportButton-container" *ngIf="!showDetail">
        <p-button [disabled]="!treeTableResults||!treeTableResults.length||isBusy" icon="pi pi-download" label="Export All" (click)="exportExcel()" class="exportButton all"/>
    </div>
    <p-treeTable id="supporting" [value]="treeTableResults" [scrollable]="true" 
        scrollHeight="flex" *ngIf="!showDetail" [loading]="isLoading">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of tableColumns" [ngStyle]="{'width': col.width + 'px'}" [ngClass]="{
                    'align-right': col.align === 'right'
                }">
                    {{ col.label }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
                <td *ngFor="let col of tableColumns; let index = index" [ngStyle]="{'width': col.width + 'px'}"
                [ngClass]="{'object-type': col.field === 'object_type' && rowNode.parent !== null,
                    'object-library': col.field === 'object_library' && rowNode.parent !== null && rowNode.node.leaf === true,
                    'object-source': col.field === 'srcmatch' && rowNode.parent !== null,
                    'align-right': col.align === 'right',
                    'object-attribute': col.field === 'attribute' && rowNode.node.leaf === true
                 }" (click)="showDetailedTable(col.field, rowData, rowNode.node)">
                    <p-treeTableToggler [rowNode]="rowNode" *ngIf="index == 0 || (index != 0 && col.expandable && rowNode.parent !== null)"></p-treeTableToggler>
                    <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                        {{ rowData[col.field] | number }}   
                    </ng-container>
                    <ng-template #notNumber>
                        {{ rowData[col.field] == 0 ? "" : rowData[col.field] }}
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <button pButton id="backButton" *ngIf="showDetail" (click)="backToSummary()">Back to Summary</button>
    <app-detail-table style="display:block;width:100%;" *ngIf="showDetail" [data]="detailTableData"></app-detail-table>
</div>